var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpegFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jpg-svgrepo-com (1) 1",
    clipPath: "url(#clip0_17231_55342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 0.5C10.35 0.5 9 1.85 9 3.5V45.5C9 47.15 10.35 48.5 12 48.5H42C43.65 48.5 45 47.15 45 45.5V12.5L33 0.5H12Z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.5 12.5H45.5L33.5 0.5V9.5C33.5 11.15 34.85 12.5 36.5 12.5Z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.5 21.5L36.5 12.5H45.5V21.5Z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45 46.5C45 47.325 44.325 48 43.5 48H10.5C9.675 48 9 47.325 9 46.5V31.5C9 30.675 9.675 30 10.5 30H43.5C44.325 30 45 30.675 45 31.5V46.5Z",
    fill: "#657B8D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.3097 35.922C20.3097 34.914 21.8937 34.914 21.8937 35.922V40.659C21.8937 42.543 20.9937 43.683 18.9192 43.683C17.8992 43.683 17.0487 43.4055 16.3047 42.447C15.6927 41.715 16.8447 40.6605 17.4687 41.427C17.9727 42.051 18.5127 42.195 19.0392 42.171C19.7097 42.147 20.2992 41.8455 20.3112 40.659V35.922H20.3097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.001 35.9218C24.001 35.5258 24.313 35.0938 24.817 35.0938H27.5875C29.1475 35.0938 30.5515 36.1377 30.5515 38.1387C30.5515 40.0347 29.1475 41.0907 27.5875 41.0907H25.585V42.6747C25.585 43.2027 25.249 43.5012 24.817 43.5012C24.421 43.5012 24.001 43.2027 24.001 42.6747V35.9218ZM25.585 36.6042V39.5922H27.5875C28.3915 39.5922 29.0275 38.8827 29.0275 38.1387C29.0275 37.3002 28.3915 36.6042 27.5875 36.6042H25.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M39.1164 42.5783C38.2644 43.2863 37.2204 43.5863 36.1659 43.5863C33.6459 43.5863 31.8594 42.1478 31.8594 39.2918C31.8594 36.8708 33.7434 34.9883 36.2724 34.9883C37.2204 34.9883 38.2629 35.3108 39.0069 36.0428C39.7374 36.7613 38.6829 37.8293 37.9644 37.1948C37.5204 36.7628 36.8964 36.4388 36.2724 36.4388C34.8219 36.4388 33.4194 37.6013 33.4194 39.2918C33.4194 41.0678 34.5939 42.1478 36.1659 42.1478C36.8964 42.1478 37.5204 41.9303 37.9644 41.6078V40.1333H36.1659C35.0979 40.1333 35.2059 38.6693 36.1659 38.6693H38.5644C39.0084 38.6693 39.4149 39.0053 39.4149 39.3773V41.9318C39.4149 42.1478 39.3204 42.3488 39.1164 42.5783Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17231_55342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpegFileIcon);
export default __webpack_public_path__ + "static/media/jpegFileIcon.0e771853b3ef012e5ebe0204786c845b.svg";
export { ForwardRef as ReactComponent };